/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostPersonalHealthRecordFileImportsRequestBodyTypename =
  "PostPersonalHealthRecordFileImportsRequestBody" as const;

/**
 *
 * @export
 * @interface PostPersonalHealthRecordFileImportsRequestBody
 */
export interface PostPersonalHealthRecordFileImportsRequestBody {
  /**
   * xml file
   * @type {string}
   * @memberof PostPersonalHealthRecordFileImportsRequestBody
   */
  xml: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostPersonalHealthRecordFileImportsRequestBody
   */
  readonly __typename?: string;
}

export function PostPersonalHealthRecordFileImportsRequestBodyFromJSON(
  json: any
): PostPersonalHealthRecordFileImportsRequestBody {
  return PostPersonalHealthRecordFileImportsRequestBodyFromJSONTyped(json, false);
}

export function PostPersonalHealthRecordFileImportsRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostPersonalHealthRecordFileImportsRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostPersonalHealthRecordFileImportsRequestBodyTypename,

    xml: json["xml"],
  };
}

export function PostPersonalHealthRecordFileImportsRequestBodyToJSON(
  object?: PostPersonalHealthRecordFileImportsRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    xml: value.xml,
  };
}
